<template>
    <div class="h100-100 h-scroll" style="padding-top: 30px;">
      <div class="slideTxtBox">
        <div class="splitViewBox">
          <div v-for='divFeild in divDatas' :key='divFeild.index' :class="['splitView', divFeild.index%2===0?'rightView':'leftView', 'normalHeight', divFeild.show?'view'+divFeild.index:'view'+(divFeild.index+1)]" >
            <div class="scale_link" state="normal"></div>
          </div>
        </div>
      </div>
      <CustomDialog ref='queryPageDialog' :element='dialog.eleQuery' :styles='dialog.styles'>
        <template v-slot:dialog-content>
          <QueryCondition ref='queryRef'></QueryCondition>
        </template>
      </CustomDialog>
    </div>
</template>

<script>
  import CustomDialog from '../../../common/CustomDialog';
  import QueryCondition from '../QueryConditionDialog';


export default {
  name: 'ChartDivCommon',
  components: {
    CustomDialog,
    QueryCondition
  },
  data() {
    return {
      divDatas: [
        {index: 1, show: true},
        {index: 2, show: true},
        {index: 3, show: true},
        {index: 4, show: true},
      ],
      dialog: {
        eleQuery: {
          target: this.$refs.grouptable,
          refName: 'queryRef',
          buttonGroup: [
            {
              click: this.closeAddImsGroupPage, buttonModel: { content: this.$t('SubscriberIms.cancel') }
            },
            {
              click: this.saveAddImsGroupPage, buttonModel: { content: this.$t('SubscriberIms.confirm'), isPrimary: true }
            },
          ],
          title: this.$t('高级搜索'),
          isClose: true
        },
        styles: {
          width: '810px',
          height: '760px',
          visible: false,
          model: true,
          zIndex: 1000
        },
      }
    };
  },
  methods:{
    openQueryPage() {
      this.$refs.queryPageDialog.show();
      this.$refs.queryRef.initTreeData();
    }
  }
};
</script>

<style scoped>

</style>
